import React from 'react';
import {
  Box,
  CustomTheme,
  darken,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { IColumn } from './interfaces';
import { useDroppable } from '@dnd-kit/core';

export const Column: React.FC<IColumn> = ({
  id,
  title,
  color = '#CCC',
  children,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();
  const { isOver, setNodeRef } = useDroppable({
    id,
  });

  return (
    <Stack
      ref={setNodeRef}
      sx={{
        flexBasis: '350px',
        flexShrink: 0,
        bgcolor: isOver
          ? darken(theme.palette.background.default, 0.05)
          : undefined,
        p: '5px',
        borderRadius: '5px',
      }}
    >
      <Box
        sx={{
          marginBottom: '10px',
          bgcolor: color,
          borderRadius: '5px',
          padding: '5px 10px',
        }}
      >
        <Typography variant="body1" color="#FFF" fontWeight="bold">
          {title}
        </Typography>
      </Box>
      <Stack rowGap="10px">{children}</Stack>
    </Stack>
  );
};
